import clsx from "clsx";
import React, { useContext, useEffect, useRef, useState } from "react";
import { GridLoader } from "../../rcsgrid/createGridTools";
import { createGrid, createRecordSource } from "../../rcsgrid/rcsgrid";
import dialogStyles from "./Components/dialogStyles.module.css";
import { SmetaModalsButtonsContext } from "../../Tools/modalManager";

interface GridObj {
  grid: createGrid;
  source: createRecordSource;
}

interface Props {
  props: {
    Buttons?: number | string;
    columns: { title: Array<any> };
    defaultFields: Array<any>;
    keyField: string;
    recordKeys: Array<string>;
    records: Array<any>;
    rights: string;
    hiddenButton?: boolean;
    setData: (newRecords: Array<any>) => void;
  };
}

export interface CheckData {
  CheckState: string;
}

/**
 * Контент диалога простая таблица
 *
 * Поля компонента:
 *    1. [mainGrid, setMainGrid] - управление состоянием таблицы
 *    2. [selectedRecordId, setSelectedRecordId] - выбранный элемент
 *    3. gridPanel - ссылка на таблицу
 *    4. recordsArr - массив записей
 *
 * @param {Object} [props] объект с данными для компонента подразделений
 * @param {string} [props.Buttons] настрока видимых кнопок
 * @param {string} [props.columns] колонки для таблицы
 * @param {Object} [props.defaultFields] колонки по умолчанию для таблицы
 * @param {string} [props.keyField] ключи колонок
 * @param {string} [props.recordKeys] ключи записи
 * @param {string} [props.records] записи
 * @param {string} [props.rights] права редактирования
 * @param {string} [props.hiddenButton] скрытие кнопок
 * @param {string} [props.setData] функция на редактирование таблицы
 *
 * @returns Возвращает контент диалога для простой таблицы
 */
export default function DialogSimpleLocalTable({ props }: Props) {
  const {
    Buttons: buttons,
    columns,
    defaultFields,
    keyField,
    recordKeys,
    records,
    rights,
    hiddenButton,
    setData,
  } = props;
  const [mainGrid, setMainGrid] = useState<GridObj | undefined>();
  const [selectedRecordId, setSelectedRecordId] = useState("0");

  const gridPanel = useRef<HTMLDivElement | null>(null);
  const recordsArr = useRef<Array<any>>(records || []);

  const setButtons = useContext(SmetaModalsButtonsContext);

  /**
   * Инициализация локальной таблицы
   */
  const loadGrid = async () => {
    const res = await GridLoader(gridPanel.current, props, {
      localGrid: true,
      refresh: false,
      Columns: columns,
      defaultFields: defaultFields,
      keyField: keyField,
      recordKeys: recordKeys,
      Rights: rights,
      getRecords: () => recordsArr.current,
      setSelectedRecord: setSelectedRecordId,
      getFieldText: getFieldText,
      onPostRecord: changeRecordData,
    });
    setMainGrid(res);
  };
  useEffect(() => {
    loadGrid();
  }, []);

  useEffect(() => {
    if (hiddenButton) return;
    const modalButtons: { [key: number]: { label: string; onClick?: () => void } } = {};
    if (!buttons || Number(buttons) & 1) {
    }
    modalButtons[2] = { label: "Закрыть" };
    setButtons?.(modalButtons);
  }, [setButtons]);

  /**
   * Обновление записей в таблице снаружи
   */
  const refreshTable = () => {
    recordsArr.current = records || [];
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    mainGrid && mainGrid.grid.refreshSource("!");
  };
  useEffect(refreshTable, [props]);

  /**
   * Возвращает текст для ячейки
   * @param request данные от таблицы
   * @returns
   */
  const getFieldText = (request: { RecordIndex: number; FieldName: string }) => {
    if (recordsArr.current.length) {
      const recVal = recordsArr.current[request.RecordIndex];
      return { Text: recVal[request.FieldName]?.text || recVal[request.FieldName] };
    }
    return { Text: "" };
  };

  /**
   * Устанавливает новые значения данных таблицы
   * @param request данные от таблицы
   * @param recordData данные записи от таблицы
   */
  const changeRecordData = (request: any, recordData: any) => {
    const recVal = recordsArr.current[request.RecordIndex];
    const atributtes = request.RecordSet.Attributes;
    atributtes.forEach((field: any, index: number) => {
      recordsArr.current[request.RecordIndex] = { ...recVal, [field]: recordData[index].text };
    });
    setData?.(recordsArr.current);
  };

  return (
    <div className={clsx(dialogStyles.mainDialogBlock)}>
      <div className={clsx(dialogStyles.fullDialogFlexContainer, dialogStyles.dialogDayTypeContainer)}>
        <div ref={gridPanel} style={{ height: "100%", width: "100%", position: "relative" }}></div>
      </div>
    </div>
  );
}
